import Shadowable from './Shadowable';
export default Shadowable;
